@for (template of reportTemplates; track template) {
  <div>
    @if (perimeter && !reportLoading) {
      <button class='form-control available-download'
        (click)="showPerimeterReportTemplateDialog(template)"
        [ngStyle]="{'background-color': reportsColor, 'color' : reportsFontsColor}"
        >
        {{ template.label }}
      </button>
    }
    @if (reportLoading || !perimeter) {
      <button class='form-control unavailable-download' disabled>
        @if (reportLoading) {
          <span class="ag-icon ag-icon-loading" role="presentation" unselectable="on"></span>
        }
        <span>{{ template.label }}</span>
      </button>
    }
  </div>
}
